import { Component, ElementRef, Input, OnInit, SimpleChanges, ViewChild, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { Chart } from 'chart.js';

@Component({
  selector: 'pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.scss']
})
export class PieChartComponent implements OnInit {

  @Input('chartData') displayChartData
  @Input('destroyChart') chartDestroy
  @Input('drillDownData') compDrill
  @Input('_isDrill') drillDown
  @Input('resetChart') chartReset
  @Output() chartClick: EventEmitter<any> = new EventEmitter<any>();

  protected pieChartObject: Chart;
  @ViewChild('PieChartCanvas', { static: false }) private pieChartCanvas: ElementRef<any>;


  chartDataObject
  _isDestroy
  _compDrillDown
  _isDrillDown = false
  constructor(
    public _cd: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("CHART DATA", changes)
    if (changes.displayChartData && changes.displayChartData.currentValue) {
      this.chartDataObject = changes.displayChartData.currentValue
      this.renderChart()
    }
    // if (this.chartDataObject) this.renderChart()
    if (changes.compDrill && changes.compDrill.currentValue) this._compDrillDown = changes.compDrill.currentValue
    if (changes.drillDown && changes.drillDown.currentValue) this._isDrillDown = changes.drillDown.currentValue
    if (changes.chartReset && changes.chartReset.currentValue) {
      console.log("CALL THIS EVERY TIME")
      this.renderChart()
    }
  }


  // UTILITY


  resetChart() {
    this.renderChart()
  }

  renderChart() {
    if (this.pieChartObject) {
      this.pieChartObject.destroy();
    }
    console.log("CALL THIS FUNCTION OR NOT", this.chartDataObject)
    this.pieChartObject = new Chart(this.pieChartCanvas.nativeElement, {
      type: this.chartDataObject.type,
      data: {
        labels: this.chartDataObject.labels,
        datasets: this.chartDataObject.datasets
      },
      options: {
        responsive: true,
        onClick: (e) => {
          this.chartClicked(e)
        }
      }
    });
  }

  chartClicked(event) {
    var activePoints = this.pieChartObject.getElementsAtEvent(event);
    var selectedIndex = activePoints[0]._index;
    console.log("ACTIVE POINT DATA WITH INDEX", activePoints, selectedIndex)
    console.log("ALL CHART DATA", this.chartDataObject)
    let data = this._compDrillDown[selectedIndex].data
    console.log("THIS IS THE DRILL DOWN DATA", this._compDrillDown, data)
    if (this.pieChartObject) {
      this.pieChartObject.destroy();
    }
    // console.log("CALL THIS FUNCTION OR NOT", this.chartDataObject)
    this.pieChartObject = new Chart(this.pieChartCanvas.nativeElement, {
      type: data.type,
      data: {
        labels: data.labels,
        datasets: data.datasets
      },
      options: {
        responsive: true,
      }
    });
    this.chartClick.emit('click')
  }



}
